import { Component, OnInit, Inject } from '@angular/core';
import { MaxPainel } from 'src/app/models/max-painel';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-cadastrar-max-painel-modal',
  templateUrl: './cadastrar-max-painel-modal.component.html',
  styleUrls: ['./cadastrar-max-painel-modal.component.scss']
})
export class CadastrarMaxPainelModalComponent implements OnInit {
  maxPainel: MaxPainel;

  constructor(
    public dialogRef: MatDialogRef<CadastrarMaxPainelModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(this.data) {
      this.maxPainel = this.data.maxPainel;
    } else {
      this.maxPainel = new MaxPainel();
    }
  }

  salvar() {
    this.maxPainel.medidaPerfil = Number(this.maxPainel.medidaPerfil);

    this.dialogRef.close(this.maxPainel);
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }


}
